<!-- 🔵 blue banner || 🟡 yellow banner -->
<div class="header-banner header-banner-yellow">
  <div class="container">
    <div class="header-banner-content">
      <div class="d-flex flex-wrap align-items-center justify-content-center-mob">
        <p class="ml-mob" data-t="header.cd_token_presale">
          {{ 'header.header-banner.pre-sale-closed' | translate }}
        </p>
      </div>
      <button
        class="btn btn-primary-new btn-icon-group btn-sm"
        (click)="openLendingTokenPage()"
      >
        <span>
          {{ 'shared.more-details' | translate }}
        </span>
        <i class="icon-arrow-btn"></i>
      </button>

      <!-- Refferal banner & PRE-SALE is Live! Get 40% Off banner ⚠️ -->
      <!-- <p>
        <span [innerHTML]="'header.header-banner.text' | translate">
        </span>&nbsp;<a routerLink (click)="openLendingTokenPage()"
          >{{'header.header-banner.more' | translate }}</a
        >
      </p>
      <button
        class="btn btn-primary"
        routerLink
        (click)="goToBuyToken()"
      >
        {{'header.header-banner.buy-token' | translate }}
      </button> -->
    </div>
  </div>
</div>
